import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UserService} from '../../../../services/user-services/user.service';
import {RedirectionTrackingService} from '../../../../services/user-services/redirection-tracking.service';
import {AuthenticationService} from '../../../../services/authentication.service';
import {Router} from '@angular/router';
import {DeviceDetectorService} from 'ngx-device-detector';
import {ProcessService} from '../../../../services/user-services/process.service';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { AccommodationRoomCardComponent } from '../accommodation-room-card/accommodation-room-card.component';
import { NgIf, NgClass, NgFor } from '@angular/common';

@Component({
    selector: 'app-accommodation-item-card',
    templateUrl: './accommodation-item-card.component.html',
    styleUrls: ['./accommodation-item-card.component.scss'],
    standalone: true,
    imports: [NgIf, NgClass, NgFor, AccommodationRoomCardComponent, TranslateModule]
})
export class AccommodationItemCardComponent implements OnInit, AfterViewInit {

  @Output() private roomIdEmitter = new EventEmitter<number>();
  private urlPrefix: string = '';

  @Input() otherRooms: any[] = [];
  @Input() favList = [];
  @Input() type: string;
  @Input() name: string;
  @Input() isLoading: boolean;
  @Input() isFocusStyle: boolean = false;
  isMobile: boolean;
  locale:string;
  isAtStart = true;
  isAtEnd = false;
  private logged = false;
  currentUser;
  public showButtons: boolean = true;

  constructor(
    private userService: UserService,
    private redirectTracker: RedirectionTrackingService,
    private router: Router,
    private authenticationService: AuthenticationService,
    private mobileDetector: DeviceDetectorService,
    private processService: ProcessService,
    private _translateService: TranslateService,

  ) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
  }

  ngOnInit(): void {
    this.locale = this._translateService.currentLang;
    this.isMobile = this.mobileDetector.isMobile();
    if (this.authenticationService.currentUserValue) {
      this.urlPrefix = '/';
      this.logged = true;
      this.currentUser = this.userService.getInfos();

    } else {
      this.logged = false;
    }
  }

  ngAfterViewInit(): void {
    this.checkIfBtnAreNeeded();
  }

  private checkIfBtnAreNeeded(): void {
    const block: any = document.getElementsByClassName('item_box_' + this.type)[0];
    this.showButtons = block.offsetWidth < block.scrollWidth;
  }

  /**
   *
   * @param room
   */
  goTo(room) {
    if (room.redirect) {
      this.redirectTracker.sendRedirectLinkInformations({
        partner: null,
        toPage: room.link,
        partnerRef: room.partner_ref,
      }).subscribe();
    } else {
      if (!room.tenant && room.disponibility && room.status == 'Listed') {
        window.open(this.locale  + '/accommodation/property/' + room.id, '_blank', 'noopener,noreferrer');
      }
    }
  }


  scrollToPrevious() {
    this.isAtEnd = false;
    const container = document.querySelector('.item_box_' + this.type);
    const previousScrollLeft = container.scrollLeft;
    const scrollStep = 250;

    container.scrollLeft -= scrollStep;
    this.isAtStart = container.scrollLeft <= 0;

    if (!this.isAtStart && container.scrollLeft === previousScrollLeft) {
      this.isAtStart = true;
    }


  }

  scrollToNext() {
    this.isAtStart = false;
    const container = document.querySelector('.item_box_' + this.type);
    const previousScrollLeft = container.scrollLeft;
    container.scrollLeft = container.scrollLeft + 250;
    this.isAtEnd = (container.scrollLeft + container.clientWidth) >= container.scrollWidth;

    if (!this.isAtEnd && container.scrollLeft === previousScrollLeft) {
      this.isAtEnd = true;
    }
  }

  propertyTrackBy(index: number, property) {
    return property.id;
  }


}
